import { render, staticRenderFns } from "./CmpImagePopup.vue?vue&type=template&id=62b1649b&scoped=true"
import script from "./CmpImagePopup.vue?vue&type=script&lang=js"
export * from "./CmpImagePopup.vue?vue&type=script&lang=js"
import style0 from "./CmpImagePopup.vue?vue&type=style&index=0&id=62b1649b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b1649b",
  null
  
)

export default component.exports